var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedPublicationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 0C4.923 0 0 4.923 0 11c0 6.078 4.923 11 11 11 6.078 0 11-4.922 11-11H11V0Z",
  fill: "#FF0082"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 5.042A5.958 5.958 0 1 0 16.958 11H11V5.042Z",
  fill: "#72166A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 20.89a1.64 1.64 0 1 0 0-3.28 1.64 1.64 0 0 0 0 3.28Z",
  fill: "#fff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.728 2.3C20.323 4.319 22 7.463 22 11H11l6.728-8.7Z",
  fill: "#FFDC00"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.728 2.3 11 11 14.95.733c1.01.394 1.944.917 2.778 1.568Z",
  fill: "#AEC90B"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M11 0c1.393 0 2.723.266 3.95.733L11 11V0Z",
  fill: "#009DC2"
})));
export default SvgFeedPublicationIcon;